import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, } from '@angular/http';
import { ConfigureServiceProvider } from '../configure-service/configure-service';
import { Observable } from 'rxjs';
@Injectable()
export class ConfigApiServiceProvider {
  driveApi: any = {};
  driveLicenseDb: any = {};
  //currentDriveApp: any = { "app_id": 839, "email_id": "raj.thulasidoss@starport.ca", "device_id": "web", "app_code": "HR88954", "app_name": "Betsy HR", "app_description": "Timesheet", "app_icon": "https://time.starport.ca/epc_assets/starport/images/starport-logo.png", "app_type": "Private", "epc_category": "STARPORT", "host": "https://time.starport.ca/", "user_id": 74, "status": "Activated", "PLUGIN_NAME": null, "PLUGIN_PATH": null, "PLUGIN_PARAM": null, "APP_EVENT": null, "isDefault": 1, "apptheme": "/epc_v2-2/framework/sptheme.css" };
  currentDriveApp: any = { "app_id": 0, "email_id": "", "device_id": "web", "app_code": "", "app_name": "", "app_description": "", "app_icon": "", "app_type": "Private", "epc_category": "STARPORT", "host": "", "user_id": 0, "status": "Activated", "PLUGIN_NAME": null, "PLUGIN_PATH": null, "PLUGIN_PARAM": null, "APP_EVENT": null, "isDefault": 1, "apptheme": "" };

  typeOfData = {
    typeStudio: 0,
    typeLookup: 1,
    typeField: 2,
    typeLogin: 3,
    typeLoopList: 4
  }
  importTempalateJSON = []
  host: string;
  summaryApi: string;
  summaryListApi: string;
  postaddApi: string;
  spPostaddApi: string;
  fieldApi: string;
  loopupListApi: string;
  publishScreenApi: string;
  pullFolder: string;
  pushFolder: string;
  runRuleApi: any;
  setGridPropsApi: any;
  gridLength: any;
  excelUploadApi: string;
  filePostAPi: any;
  userLicenseAccessApi: any;
  docTracker: any = {
    "docTracker": {
      "params": {
        "Template": "DOCTNT_HR88954",
        "tntSetup": "HR88954_TNTSETUP"
      }
    }
  }
  respMessage: any = '';
  templateMangerUrl: any = '';
  createAppApi: string;
  pullTntActivityApi: string;
  pushTntActivityApi: string;
  deleteAppApi: string;
  fetchUserLicenceAccessApi: string;
  revokeUserLicenceAccessApi: string;
  uploadFileApi: string;
  downloadFileApi: string;
  exportTempalateJSON: any;
  exportFolderJSON: any;
  Tempalatestatus: any = '';
  getTemplatefolder: any;
  excelTemplateStatus: boolean;

  config: any;
  // project_config: any = {nodeServer: "https://localhost:3784"};//local NS
  project_config: any = {};
  loginScreenApi: string;
  toastDuration: any = '2000';
  private _serverConfig = '../../config/server-config.json';
  constructor(private _http: Http, public configureService: ConfigureServiceProvider) {
    this.host = this.configureService.getHost();
    this.gridLength = 1000;
    this.publishScreenApi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + 'EPC_PUBLISH_SCREEN/';
    this.runRuleApi = this.host + '/RunWorkflow/';
    this.setGridPropsApi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + 'EPC_SET_GRID_PROPS/';
    this.loginScreenApi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + 'Login/';
    // this.excelUploadApi = this.host.replace(':82/', '').replace(':62223', '').replace('/EPC_V4.svc/', ''); // commentin out duplicate entry, one entry int he end
    // this.excelUploadApi = this.host.replace(':82/', '').replace(':3713', '').replace(':3780','').replace('/EPC_V4.svc/', ''); 
    // this.uploadFileApi = this.host.replace(':82/', '').replace(':3713', '').replace(':3780','').replace('/EPC_V4.svc/', ''); 
    // this.downloadFileApi = this.host.replace(':82/', '').replace(':3713', '').replace(':3780','').replace('/EPC_V4.svc/', ''); 
    // this.getTemplatefolder = this.host.replace(':82/', '').replace(':3713', '').replace(':3780','').replace('/EPC_V4.svc/', ''); 
    // template manger should use URL used for application, not the host url which is for API
    this.templateMangerUrl = window.location.href.replace('index.html', 'studio/index.html')
    this.createAppApi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + '/EPC_SETUP_APP/';
    // this.excelUploadApi = this.project_config.nodeServer;
    // this.uploadFileApi = this.project_config.nodeServer; + '/fileUpload';
    // this.downloadFileApi =  this.project_config.nodeServer; + '/download';
    // this.getTemplatefolder =  this.project_config.nodeServer; + ':3784/getTemplatefolder';
    this.filePostAPi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + 'POST_EXECUTE_SQL/';
    this.spPostaddApi = this.host.replace(':62223', ':62226') + 'postadd/';
    this.userLicenseAccessApi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + 'EPC_SETUP_USER_LICENSE_ACCESS/';
    this.fetchUserLicenceAccessApi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + 'EPC_FETCH_USER_LICENSE_ACCESS/';
    this.revokeUserLicenceAccessApi = this.host.replace('/EPC_V4', '/EPCSTUDIO') + 'EPC_REVOKE_USER_LICENSE_ACCESS/';
    this.pullTntActivityApi = this.host + 'PullTNTActivity/';
    this.pushTntActivityApi = this.host + 'PushTNTActivity/';
    this.deleteAppApi = this.host.replace('/EPC_V4', '/epcstudio') + 'epc_delete_epc/';

    // HARDCODED VALUE
    this.driveApi = {
      'pullDriveApps': { 'params': { "client": "eprodcast", "rptname": "EPC_APPStatus", "Reg_user_id": '', "app_code": "", "device_id": "web", "epcmode": "drive1.0", "start": 1, "end": 10 } },
      'pullLinkShareUser': { "start": 1, "end": 100, "userid": "", "rptname": "Drive_Share_User", "client": "eprodcast", "ShareID": "" },
      'dashBoardFolderMap': { 'params': { 'folder_id': "a9d85e6b-14a4-4245-aa54-9cb68360942d", 'path': [0, "aa0bb289-2b4d-4db9-8aea-ecec5baf6b1a"] } },
      'pullShareFolder': { 'params': { "userid": "", "rptname": "Driveinfo", "client": "eprodcast", "drive": "root", "appCode": "" } },
      'dashboardLoginUser': { 'params': { 'user_id': '' } },
      'deskTemplate': 'Desk',
      'newpushArray': { "params": { "type": "FILE", "userid": "" } },
      "pullRecSecurity": { 'params': { "start": 1, "end": 1000, "userid": "3280", "rptname": "recruiters756", "client": "HR88954", "requisition_id": '' } },
      "createApp": { 'params': { "app_code": "", "app_name": "Messaging", "app_description": "Messaging", "app_icon": "", "app_type": "Public", "epc_category": "Finance", "host": "http://demo.eprodcast.com/", "email_id": "", "device_id": "web", "password": "", "Update": "NEW" } },
      "createUser": { 'params': { "client": "", "rptname": "", "targetepc": "", "emailid": "", "deviceid": "web", "password": "", "createlicense": "YES", "load_default": "YES", "no_of_license": "1", "createuser": "YES" } },
      "updateApp": { 'params': { "app_code": "", "app_name": "Messaging", "app_description": "Messaging", "app_icon": "", "app_type": "Public", "epc_category": "Finance", "host": "http://demo.eprodcast.com/", "email_id": "", "device_id": "web", "password": "", "Update": "EDIT" } },
      'updateUser': { 'params': { "client": "", "rptname": "", "targetepc": "", "emailid": "", "deviceid": "web", "password": "", "createlicense": "YES", "no_of_license": "1", "createuser": "NO", "load_default": "YES", "reg_user_id": "" } },
      'revokeUser': { 'params': { "emailid": "test1@epc.com", "targetepc": "Susira13", "deviceid": "web" } },
      'pushMailShareUser': { 'params': { "client": "StudioApp11", "rptname": "Drive_share_mail", "TOID": "", "CC": "", "BCC": "", "FROMID": "", "SUBJECT": "", "BODY": "", "ShareID": "", "userid": "3280" } },
      'rulesClone': { 'params': { "RuleID": "", "RuleName": "", "rptname": "EPC_BRE_Rules_Clone", "userid": "", "client": "" } },
      'pullTntActivity': { 'params': { "client": "", "userid": "", "folderID": "" } },
      'pushTntActivity': { 'params': { "client": "", "userid": "", "activityID": "0", "folderID": "", "templateID": "", "recordID": "", "usercode": "", "status": "1", "activityHistory": [] } },
      'deleteApp': { 'params': { "targetepc": "" } },
      'loginApiParam': { 'params': { "start": 1, "end": 1000, "userid": this.configureService.getLoginUserID() } },
    };
    this.summaryApi = this.host + 'summary/';
    this.summaryListApi = this.host + 'summarylist/';
    this.postaddApi = this.host + 'postadd/';
    this.fieldApi = this.host + 'GetFieldProperties/';
    this.loopupListApi = this.host + 'LoopupList/';
    this.pullFolder = this.host + 'pullfolder/';
    this.pushFolder = this.host + 'pushFolder/';
    this.getProjectConfig();
    // this.pullApiData();
  }
  pullApiData(callback) {
    let userid = this.configureService.getLoginUserID();

    //  if(Object.keys(this.driveApi).length<=1){
    let studioCode = this.configureService.getStudio();
    let data = { "start": "1", "end": "100", "userid": userid, "rptname": "DRIVE_CONFIGURATION", "app_code": this.currentDriveApp['app_code'], "client": studioCode };
    this.pullRequest(data, (respdata) => {
      Object.assign(this.driveApi, this.pullApiDataResponse(respdata));
      callback(this.driveApi);
    });
    //  }else{
    //   callback(this.driveApi);
    //  }    
  }

  pullApiDataResponse = ((data) => {
    let systemApi: any;
    systemApi = data[0].System_API;
    if (systemApi) {
      systemApi = eval("(" + systemApi + ")");
      return systemApi;
    }
  })

  pullLicenseDbRequestParam(callback) {
    let userid = this.configureService.getLoginUserID();

    //  if(Object.keys(this.driveApi).length<=1){
    let studioCode = this.configureService.getStudio();
    let data = { "start": "1", "end": "100", "userid": '', "rptname": "DRIVE_CONFIGURATION", "app_code": '', "client": 'eprodcast' };
    this.pullRequest(data, (respdata) => {
      Object.assign(this.driveLicenseDb, this.pullLicenseDbResponse(respdata));
      callback(this.driveLicenseDb);
    });
  }

  pullLicenseDbResponse = ((data) => {
    let systemApi: any;
    systemApi = data[0].System_API;
    if (systemApi) {
      systemApi = eval("(" + systemApi + ")");
      return systemApi;
    }
  })

  pullRequest(indata, callback) {
    this.postApi(this.summaryApi, indata, (respdata) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          callback(JSON.parse(respdata["_POST_SummaryMethodResult"]));
        } else {
          callback(null);
        }
      }
    });
  }

  pullSummaryListRequest(indata, callback) {
    this.postApi(this.summaryListApi, indata, (respdata) => {
      if (respdata["_POST_SummaryListResult"].length > 0) {
        if (respdata["_POST_SummaryListResult"] !== "FAIL") {
          callback(JSON.parse(respdata["_POST_SummaryListResult"]));
        } else {
          callback(null);
        }
      }
    });
  }

  pushSPRequest(indata, callback) {
    this.postApi(this.spPostaddApi, indata, (respdata) => {
      if (respdata["_POST_AddMethodResult"].length > 0) {
        var _data = {};
        var _responseData = respdata["_POST_AddMethodResult"][0];
        _data['Result'] = _responseData.Result;
        if (_responseData.Result == "SUCCESS") {
          ////////////////////////////////////
          // callback(_responseData.Result);
          ////////////////////////////////////
          var ref = _responseData.Ref_ID;
          if (ref) {
            ref = eval("(" + ref + ")");
            _data = Object.assign({}, ref);
            callback(_data);
            // for(var m in ref){
            //   _data = Object.assign({},_data,ref[m]);
            // }
          } else {
            callback(_responseData.Result);
          }
        } else if (_responseData.Result == "FAILED" || _responseData.Result == "FAIL") {
          if (_responseData.Message) {
            _data = Object.assign({}, _data, JSON.parse(_responseData.Message));
            this.respMessage = _data['Message']
          } else {
            this.respMessage = 'Record Saved Failed!.Please try again..'
          }
          _data = _data["Result"];
          callback(_data);
        }
      }
      // callback(_data);
    })
  }

  pushRequest(indata, callback) {
    this.postApi(this.postaddApi, indata, (respdata) => {
      if (respdata["_POST_AddMethodResult"].length > 0) {
        var _data = {};
        var _responseData = respdata["_POST_AddMethodResult"][0];
        _data['Result'] = _responseData.Result;
        if (_responseData.Result == "SUCCESS") {
          ////////////////////////////////////
          // callback(_responseData.Result);
          ////////////////////////////////////
          var ref = _responseData.Ref_ID;
          if (ref) {
            ref = eval("(" + ref + ")");
            _data = Object.assign({}, ref);
            callback(_data);
            // for(var m in ref){
            //   _data = Object.assign({},_data,ref[m]);
            // }
          } else {
            callback(_responseData.Result);
          }
        } else if (_responseData.Result == "FAILED" || _responseData.Result == "FAIL") {
          this.respMessage = '';
          if (_responseData.Message) {
            _data = Object.assign({}, _data, JSON.parse(_responseData.Message));
            this.respMessage = _data['Message']
          } else {
            this.respMessage = 'Record Saved Failed!.Please try again..'
          }
          callback(_data);
        }
      }
      // callback(_data);
    })
  }

  fieldpropertyRequest(indata, callback) {
    this.postApi(this.fieldApi, indata, (respdata) => {
      if (respdata["_POST_FieldPropertyMethodResult"].length > 0) {
        let _data = respdata["_POST_FieldPropertyMethodResult"];
        if (respdata["_POST_FieldPropertyMethodResult"] !== "FAIL") {
          callback(_data);
        } else {
          // resolve(data)
        }
      }
    });
  }

  customRequest(api, indata, callback) {
    this.postApi(api, indata, (respdata) => {
      callback(respdata);
    });
  }

  /////////////
  /* * * * * *
  * excel upload
  * * * * * */
  async uploadExcelData(formData, cbck) {
    var xhr = new XMLHttpRequest();
    var reponse = "";
    var url = this.project_config.nodeServer + '/upload/data';
    formData.append('api', this.postaddApi);
    xhr.open('POST', url, true);
    xhr.onload = function (e) {
      reponse = xhr.responseText;
      cbck(reponse);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          // alert("Excel Uploaded Successfully !!");
        } else {
          var response = {'result':"FAIL"}
          cbck(JSON.stringify(response))
          // alert("Excel Upload Falied !!");
        }
      }
    };
    xhr.send(formData);
  }
  /////////////
  /* * * * * *
  *Upload File
  * * * * * */
  async uploadFile(formData, cbck) {
    var xhr = new XMLHttpRequest();
    var reponse = "";
    //var url = "https://localhost:3784/fileUpload";
    formData.append('app_code', this.currentDriveApp['app_code']);
    var url = this.project_config.nodeServer + '/fileUpload';
    xhr.open('POST', url, true);
    xhr.onload = function (e) {
      reponse = xhr.responseText;
      cbck(reponse);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          // alert("Excel Uploaded Successfully !!");
        } else if (xhr.responseText == "") {
          alert('Upload Failed');
        } else {
          alert(xhr.responseText)
        }
      }
    };
    xhr.send(formData);
  }



  /////////////
  /* * * * * *
  *Download File
  * * * * * */
  async downloadFile(fileName, cbck) {
    var xhr = new XMLHttpRequest();
    var reponse = "";
    //var url = "https://localhost:3784/download"; 
    var url = this.project_config.nodeServer + '/download';
    xhr.open('POST', url, true);
    // xhr.responseType ='blob'
    xhr.setRequestHeader("Content-Type", "application/json");

    // xhr.responseType ='blob'
    xhr.onload = function (e) {
      reponse = xhr.responseText;
      cbck(reponse);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          // alert("Excel Uploaded Successfully !!");
        }
      }
    };
    xhr.send(JSON.stringify(fileName));
  }

  async getFolderTemplate(fileName, cbck) {
    var xhr = new XMLHttpRequest();
    var reponse = "";
    //var url = "https://localhost:3784/getTemplatefolder"; 
    var url = this.project_config.nodeServer + '/getTemplatefolder';
    xhr.open('POST', url, true);
    // xhr.responseType ='blob'
    xhr.setRequestHeader("Content-Type", "application/json");

    // xhr.responseType ='blob'
    xhr.onload = function (e) {
      reponse = xhr.responseText;
      cbck(reponse);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          // alert("Excel Uploaded Successfully !!");
        }
      }
    };
    xhr.send(JSON.stringify(fileName));
  }


  /////////////
  pullData(fieldDataRef, fieldData, api, type, callback) {
    if (type == this.typeOfData.typeStudio) {
      this.configServiceScreenApi(fieldData, callback);
    } else if (type == this.typeOfData.typeLookup) {
      this.configServiceLookup(fieldDataRef, fieldData, callback);
    } else if (type == this.typeOfData.typeLoopList) {
      this.configServiceLoopList(fieldData, callback);
    }
  }



  private configServiceScreenApi(ffdata, callback) {
    let data = {}
    // data =Object.assign({},{"client":"Studio88953","userid":88,"start":1,"end":10,"rptname":"XAPP_FIELD_PROPERTIES41"},ffdata);
    //@santhiya commented above line to get request from drive api
    data = Object.assign({}, this.driveApi.pullFieldData.params, ffdata, { "client": this.configureService.getStudio() });
    this.pullSummaryData(data, callback);
  }

  private configServiceLookup(fieldDataRef, fieldData, callback) {
    let data = {};
    // data ={"client":"Studio88953","rptname":"Field_Lookup11","userid":"3994","field_properties_id":fieldDataRef};
    //@santhiya commented above line to get request from drive api
    data = Object.assign({}, this.driveApi.pullLookupData.params, { "field_properties_id": fieldDataRef, "client": this.configureService.getStudio() });
    this.pullFieldData(data, callback);
  }

  private configServiceLoopList(ffdata, callback) {
    this.pullLoopList(ffdata, callback);
  }

  pushData(ffdata, type, callback) {
    if (type == this.typeOfData.typeField) {
      this.configServicePostFieldData(ffdata, callback);
    }
  }

  configServicePostFieldData(data, callback) {
    // let objData = Object.assign({},data,{"client":"Studio88953","userid":88,"rptname":"XAPP_FIELD_PROPERTIES34"})
    //@santhiya commented above line to get request from drive api
    let objData = Object.assign({}, this.driveApi.pushFieldProperty.params, data, { "client": this.configureService.getStudio() });
    this.pushPostData(objData, callback);
  }

  private pullSummaryData(data, callback) {
    let headers = this.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this._http.post(this.summaryApi, this.srtingifyDataForEpc(data), options)

        .map(res => res.json())
        .subscribe(data => {
          this.handleSummaryData(data, callback);
        })
    })
  }

  private pullFieldData(data, callback) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this._http.post(this.fieldApi, this.srtingifyDataForEpc(data), options)

        .map(res => res.json())
        .subscribe(data => {
          this.handleFieldData(data, callback);
        })
    })
  }

  //////////////////////////// Get AppList Type ////////////////////////////////////
  getApplist(cbck) {
    this.driveApi['pullDriveApps']['params'] = Object.assign({}, this.driveApi['pullDriveApps']['params'], { 'Reg_user_id': this.configureService.getLoginUserID() })
    this.pullSummaryData(this.driveApi['pullDriveApps']['params'], (appList) => {
      appList.forEach(element => {
        if (element.isDefault == '1') {
          console.log('activeApp', element);
          this.currentDriveApp = element;
        }
      });
      cbck(appList)
    })
    // remove later
    // this.currentDriveApp = {"app_id":839,"email_id":"raj.thulasidoss@starport.ca","device_id":"web","app_code":"HR88954","app_name":"Betsy HR","app_description":"Timesheet","app_icon":"https://time.starport.ca/epc_assets/starport/images/starport-logo.png","app_type":"Private","epc_category":"STARPORT","host":"https://time.starport.ca/","user_id":74,"status":"Activated","PLUGIN_NAME":null,"PLUGIN_PATH":null,"PLUGIN_PARAM":null,"APP_EVENT":null,"isDefault":1,"apptheme":"/epc_v2-2/framework/sptheme.css"};
  }

  private pullLoopList(data, callback) {
    let headers = this.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this._http.post(this.loopupListApi, this.srtingifyDataForEpc(data), options)

        .map(res => res.json())
        .subscribe(data => {
          this.handleLoopListData(data, callback);
        })
    })
  }
  private pushPostData(data, callback) {
    let headers = this.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this._http.post(this.postaddApi, this.srtingifyDataForEpc(data), options)
        .map(res => res.json())
        .subscribe(data => {
          this.handlePostData(data, callback);
        })
    })
  }

  private handleSummaryData(data, callback) {
    if (data["_POST_SummaryMethodResult"].length > 0) {
      let _data = data["_POST_SummaryMethodResult"];
      if (data["_POST_SummaryMethodResult"] !== "FAIL") {
        callback(JSON.parse(_data));
      } else {
        // resolve(data)
      }
    }
  }

  private handleFieldData(data, callback) {
    if (data["_POST_FieldPropertyMethodResult"].length > 0) {
      let _data = data["_POST_FieldPropertyMethodResult"];
      if (data["_POST_FieldPropertyMethodResult"] !== "FAIL") {
        callback(_data);
      } else {
        // resolve(data)
      }
    }
  }

  private handleLoopListData(data, callback) {
    if (data["_POST_LookupListMethodResult"].length > 0) {
      let _data = data["_POST_LookupListMethodResult"];
      if (data["_POST_FieldPropertyMethodResult"] !== "") {
        callback(_data);
      } else {
        // resolve(data)
      }
    }
  }

  private handlePostData(data, callback) {
    if (data["_POST_AddMethodResult"].length > 0) {
      var _data = {};
      var _responseData = data["_POST_AddMethodResult"][0];
      _data['Result'] = _responseData.Result;
      if (_responseData.Result == "SUCCESS") {
        var ref = _responseData.Ref_ID;
        if (ref) {
          ref = eval("(" + ref + ")");
          for (var m in ref) {
            _data = Object.assign({}, _data, ref[m]);
          }
        }
      } else if (_responseData.Result == "FAILED" || _responseData.Result == "FAIL") {
        if (_responseData.Message) {
          _data = Object.assign({}, _data, JSON.parse(_responseData.Message));
          this.respMessage = _data['Message']
        } else {
          this.respMessage = 'Record Saved Failed!.Please try again..'
        }
        _data = _data["Result"];
        callback(_data);
      }
    }
    callback(_data);
  }



  private srtingifyDataForEpc(json): string {
    let obj = { data: JSON.stringify(json) };
    let pdata = JSON.stringify(obj);
    return pdata;
  }

  getJSON(url = null): Observable<any> {
    var res = this._http.get(this._serverConfig);
    return res;
  }

  getProjectConfig() {
    let self = this;
    return new Promise((resolve, reject) => {
      if (self.config) {
        resolve(self.config)
      } else {
        self.getJSON().subscribe(data => {
          data = JSON.parse(data._body);
          self.config = data[data["config"]];
          this.project_config = data[data["config"]];
          console.log("data config", this.project_config)
          resolve(self.config)
        },
          error => reject(error)
        );
      }
    })
  }

  //***LOGIN API - get Security Token ***
  postLoginApi(api, user_name, user_pass, data, callback) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.set('email_id', user_name)
    headers.set('password', user_pass)
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this._http.post(this.loginScreenApi, this.srtingifyDataForEpc(data), options)
        .map(res => res.json())
        .subscribe(data => {
          callback(data);
        })
    })
  }

  //***Other API calling Method ***
  private postApi(api, data, callback) {
    let headers = this.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this._http.post(api, this.srtingifyDataForEpc(data), options)
        .map(res => res.json())
        .subscribe(data => {
          callback(data);
        })
    })
  }

  setHeaders(){
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let aceessToken = this.configureService.getAccessToken();
    headers.set('ACCESSKEY', 'client')
    headers.set('APIKEY', 'rptname')
    headers.set('TOKEN', aceessToken);
    return headers;
  }

}



// WEBPACK FOOTER //
// ./src/providers/config-api-service/config-api-service.ts